import * as React from 'react';

import TimeFormat from '../lib/TimeFormat';

interface IProps {
  currentTime: number | null,
}

const Timestamp: React.SFC<IProps> = ({currentTime}: IProps) => {
  let timeStamp = '';
  if (currentTime) {
    timeStamp = TimeFormat.toHHMMSS(currentTime);
  }

  return (
    <span className="time-stamp">{ timeStamp }</span>
    );
}

export default Timestamp;



// WEBPACK FOOTER //
// ./src/components/Timestamp.tsx